import React, { useState } from 'react'
import { bool } from 'prop-types'
import classnames from 'classnames'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'
import { Fade } from 'components/atoms/Animista'

import WindowTabs from 'components/organisms/WindowTabs'

import Relazsizes from 'relazsizes'

import config from 'config'

import riasecData from './riasec.json'

const { assets_url: assetsUrl } = config

const RIASECTabs = ({ fullContent }) => {
  const getActiveId = () => riasecData[0].id
  const [activeTab, setActiveTab] = useState(getActiveId)

  return (
    <>
      <Container>
        <Typography component="h2" variant="title" className="text-variant-title-sm text-center">
          Tipe Kepribadian Berdasarkan RIASEC
        </Typography>
        <div className="riasec-tabs__charas">
          <Row>
            {
              riasecData.map((chara, idx) => (
                <Col
                  className={classnames({ 'mobile-hidden': chara.id !== activeTab })}
                  md="2"
                  key={`riasec-chara-${idx}`}
                >
                  <div
                    className={classnames('riasec-tabs__chara-item', {
                      active: chara.id === activeTab,
                    })}
                    onClick={() => setActiveTab(chara.id)}
                  >
                    <Fade active={activeTab === chara.id}>
                      <Relazsizes
                        className="riasec-tabs__chara-img"
                        dataSrc={`${assetsUrl}/assets/img/aptitude/characters/${chara.title.toLowerCase()}-2x.png`}
                        alt={`Karakter ${chara.title} | Tes Minat Bakat - Quipper Campus`}
                      />
                      <Typography
                        className="riasec-tabs__chara-name"
                        component="h4"
                        variant="headline"
                      >
                        {chara.title}
                      </Typography>
                    </Fade>
                  </div>
                </Col>
              ))
            }
          </Row>
        </div>
      </Container>
      <Container className="riasec-tabs__container" mobileFull>
        <WindowTabs
          tabs={riasecData}
          activeId={activeTab}
          onTabSelect={id => setActiveTab(id)}
          fullContent={fullContent}
        />
      </Container>
      <style jsx>
        {`
          .riasec-tabs {
            &__charas {
              margin: 48px 0 24px;
              @media screen and (min-width: 768px) {
                margin: 48px 0
              }
            }
            :global(&__chara-img) {
              width: 100%;
              opacity: 0.3;
            }
            :global(.mobile-hidden) {
              @media screen and (max-width: 767px) {
                display: none;
              }
            }
            :global(&__chara-name) {
              text-align: center;
              color: #0c2846;
              padding-top: 16px;
              @media screen and (min-width: 768px) {
                display: none;
              }
            }
            &__chara-item {
              width: 100%;
              cursor: pointer;
              display: none;
              @media screen and (min-width: 786px) {
                display: block;
              }
              &.active {
                display: block;
                :global(.riasec-tabs__chara-img) {
                  width: 100%;
                  opacity: 1 !important;
                }
              }
              :global(.fade-in),
              :global(.fade-out) {
                @media screen and (min-width: 768px) {
                  animation: unset;
                }
              }
            }
          }
        `}
      </style>
    </>
  )
}

RIASECTabs.propTypes = {
  fullContent: bool,
}

export default RIASECTabs
